import React, { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { HashRouter as Router } from "react-router-dom";
import Views from "./views";
import { Route, Switch } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import controleAbasService from "./services/TabControlService";
import MaxTabsWarningModal from "./components/atom/MaxTabsWarningModal";

const themes = {
	dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
	light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
	useEffect(() => {
		// Inicializar o controle de abas
		if (controleAbasService.deveMostrarAviso()) {
			console.warn('Limite de abas atingido');
		}
	}, []);

	return (
		<div className="App">
			<Provider store={store}>
				<ThemeSwitcherProvider
					themeMap={themes}
					defaultTheme={THEME_CONFIG.currentTheme}
					insertionPoint="styles-insertion-point"
				>
					<Router>
						<Switch>
							<Route path="/" component={Views} />
						</Switch>
					</Router>
					<MaxTabsWarningModal />
				</ThemeSwitcherProvider>
			</Provider>
		</div>
	);
}

export default App;
